import styled, { css } from 'styled-components';
import AntLink from 'antd-core/es/typography/Link';
import { uppercase, textAlign, whiteSpace } from '@10d/tend-ui-styling';

const Root = styled(AntLink).attrs({
    $sizes: {
        small: css `
      font-size: 12px;
      line-height: 16px;
    `,
        medium: '',
        large: css `
      font-size: 16px;
      line-height: 24px;
    `,
    },
}) `
  &.tend-ui-typography {
    display: inline-flex;
    gap: 4px;

    & > u {
      gap: 4px;
      display: inline-flex;
    }

    ${props => props.$sizes[props.$size]};
    ${uppercase};
    ${props => props.$textAlign &&
    css `
        display: inline-block;
        ${textAlign};
      `}

    ${whiteSpace};

    ${props => !props.$disabled &&
    css `
        &:focus {
          border-radius: 4px;
          background-color: ${props.$theme.colors['blue150-transparent']};
        }
      `}

    .anticon {
      font-size: 16px;
    }
  }
`;

export { Root };
//# sourceMappingURL=styled.js.map
